import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-701df069.js';
import { f as focusOutlineMixin } from '../../FocusIndicator/styleMixins/focusOutline-ae6f4c7f.js';
import { I as Icon } from '../../Icon/Icon-258a20fc.js';

const switchSize = key => ({
  small,
  theme
}) => theme.switch[small ? 'small' : 'normal'][key];
const switchMobileSize = key => ({
  small,
  theme
}) => theme.switch[small ? 'small' : 'normal'].mobile[key];
const switchStyle = /*#__PURE__*/css(["position:relative;display:inline-block;vertical-align:middle;box-sizing:border-box;height:", "px;width:", "px;", " :focus{outline:none;}opacity:", ";svg{color:white;display:flex;width:", "px;opacity:", ";}"], switchSize('innerHeight'), switchSize('innerWidth'), isMobile(css(["height:", "px;width:", "px;"], switchMobileSize('innerHeight'), switchMobileSize('innerWidth'))), ({
  disabled,
  theme
}) => disabled ? theme.switch.disabledOpacity : 1, switchSize('innerCheckSize'), ({
  disabled,
  theme
}) => disabled ? theme.switch.disabledOpacity : 1);
const switchPaddleSize = key => ({
  small,
  theme
}) => theme.switch.paddle[small ? 'small' : 'normal'][key];
const switchMobilePaddleSize = key => ({
  small,
  theme
}) => theme.switch.paddle[small ? 'small' : 'normal'].mobile[key];
const switchPaddleOffset = ({
  small,
  theme,
  toggled
}) => toggled ? theme.switch.paddle[small ? 'small' : 'normal'].checkedTranslateOffset : 0;
const switchMobilePaddleOffset = ({
  small,
  theme,
  toggled
}) => toggled ? theme.switch.paddle[small ? 'small' : 'normal'].mobile.checkedTranslateOffset : 0;
const switchBgColor = key => ({
  toggled,
  disabled,
  theme
}) => {
  const toggledObj = theme.switch.paddle[toggled ? 'checked' : 'default'];
  return disabled ? toggledObj.disabled || toggledObj[key] : toggledObj[key];
};
const SliderButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-30039089__sc-9i5t91-0"
})(["cursor:", ";position:absolute;top:0;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms;}border-radius:", ";width:100%;height:100%;background-color:", ";:hover{background-color:", ";}:active{background-color:", ";}padding:1px ", "px;border:none;", " :hover{::before{border:none;}}:focus{outline:none;", "}::before{opacity:", ";box-sizing:border-box;position:absolute;content:\"\";top:", "px;left:", "px;inset-inline-start:", "px;right:auto;inset-inline-end:auto;transition-property:transform;@media (prefers-reduced-motion:no-preference){transition-duration:", ";}background:", ";border:none;border-radius:", ";box-shadow:", ";height:", "px;width:", "px;/*! @noflip */ transform:translateX(", "px);", "}/*! @noflip */ [dir=\"rtl\"] &&::before{right:", "px;inset-inline-start:", "px;left:auto;inset-inline-end:auto;/*! @noflip */ transform:translateX(-", "px);", "}"], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  theme
}) => theme.switch.paddle.borderRadius, switchBgColor('bg'), switchBgColor('hover'), switchBgColor('active'), switchSize('innerPadding'), isMobile(css(["border-radius:12px;padding:1px ", "px;"], switchMobileSize('innerPadding'))), ({
  focusVisible
}) => focusVisible && focusOutlineMixin, ({
  disabled,
  theme
}) => disabled ? theme.switch.disabledOpacity : 1, switchPaddleSize('topOffset'), switchPaddleSize('leftOffset'), switchPaddleSize('leftOffset'), ({
  theme
}) => theme.switch.slideTransition, ({
  theme
}) => theme.switch.paddle.bg, ({
  theme
}) => theme.switch.paddle.borderRadius, ({
  theme
}) => theme.switch.paddle.boxShadow, switchPaddleSize('paddleHeight'), switchPaddleSize('paddleWidth'), switchPaddleOffset, isMobile(css(["height:", "px;width:", "px;/*! @noflip */ transform:translateX(", "px);"], switchMobilePaddleSize('paddleHeight'), switchMobilePaddleSize('paddleWidth'), switchMobilePaddleOffset)), switchPaddleSize('leftOffset'), switchPaddleSize('leftOffset'), switchPaddleOffset, isMobile(css(["/*! @noflip */ transform:translateX(-", "px);"], switchMobilePaddleOffset)));
const switchIconStyle = key => ({
  $small,
  theme
}) => theme.switch[$small ? 'small' : 'normal'][key];
const switchIconMobileStyle = key => ({
  $small,
  theme
}) => theme.switch[$small ? 'small' : 'normal'].mobile[key];
const Checkmark = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30039089__sc-9i5t91-1"
})(["visibility:", ";@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms;}display:flex;svg{font-size:", "px;opacity:", ";", "}"], ({
  $toggled,
  $disabled
}) => $disabled && !$toggled ? 'hidden' : 'visible', switchIconStyle('innerCheckSize'), ({
  $disabled,
  theme
}) => $disabled ? theme.switch.disabledOpacity : 1, isMobile(css(["font-size:", "px;"], switchIconMobileStyle('innerCheckSize'))));

export { Checkmark as C, SliderButton as S, switchStyle as s };
//# sourceMappingURL=InnerSwitch.styles-0fb73c91.js.map
